class UspMarquee extends HTMLElement {
  constructor() {
    super();
    this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
    this.list = this.querySelector('.usp-marquee__list');
    this.track = this.querySelector('.usp-marquee__track');
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    if (!this.list || !this.track) return;

    this.mobileMediaQuery.addEventListener('change', this.update);
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.list);
    this.update();
  }

  disconnectedCallback() {
    this.mobileMediaQuery.removeEventListener('change', this.update);
    this.resizeObserver?.disconnect();
  }

  update() {
    if (!this.mobileMediaQuery.matches) {
      this.clone?.remove();
      this.clone = null;
      this.classList.remove('is-ready');
      return;
    }

    if (!this.clone) {
      this.clone = this.list.cloneNode(true);
      this.clone.classList.add('usp-marquee__list--clone');
      this.clone.setAttribute('aria-hidden', 'true');
      this.clone.querySelectorAll('[data-shopify-editor-block]').forEach(element => {
        element.removeAttribute('data-shopify-editor-block');
      });
      this.track.append(this.clone);
    }

    const pixelsPerSecond = 40;
    const minimumDuration = 12;
    const duration = Math.max(this.list.scrollWidth / pixelsPerSecond, minimumDuration);

    this.style.setProperty('--usp-marquee-duration', `${duration}s`);
    this.classList.add('is-ready');
  }
}

if (!customElements.get('usp-marquee')) {
  customElements.define('usp-marquee', UspMarquee);
}
